<template>
  <div class="deposit-pages">
    <!-- <div class="p16 align-items"> -->
    <div class="p8 align-items">
        <div>产品寄存</div>
        <el-button type="primary" @click="addClick()" v-perm="{key:'deposit', value: 'deposit:add'}">添加寄存</el-button>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row space-between">
              <div class="flex-row">
                <el-select v-model="query.status" class="select" placeholder="消费项目">
                  <el-option label="全部类型" value></el-option>
                  <el-option label="已领取" value="hasGet"></el-option>
                  <el-option label="待领取" value="notGet"></el-option>
                </el-select>
              </div>
              <div class="flex-row ml10">
                <el-select v-model="query.staffIds" class="select" placeholder="服务技师">
                  <el-option label="全部技师" value></el-option>
                  <el-option
                    v-for="(item,index) in staffList"
                    :key="index"
                    :label="item.staffName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              
            </div>
            <div class="flex-row ml10">
              <v-date @time="changeDate"></v-date>
            </div>
            <el-input
                placeholder="手机号/身份证号"
                v-model="query.keyword"
                clearable
                class="w200 ml10 mr10"
              ></el-input>
            <el-button type="primary" @click="searchDoQuery">搜索</el-button>
          </div>
          <div class="m16 white" v-perm="{key:'deposit', value: 'deposit:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column
                :prop="index"
                :align="item.align"
                :label="item.label"
                :width="item.width"
                :min-width="item.minWidth"
                :show-overflow-tooltip="false"
                v-for="(item,index) in columns"
                :key="index"
              >
                <template slot-scope="scope">
                  <div>{{Boolean(item.formatDay)?formatDate(scope.row[index]):scope.row[index]}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-link type="primary" @click="handleClick(scope.row)">寄存信息</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editForm" @change="refreshPage"></edit-set>
    <addDeposit-set ref="addDepositForm" @change="addDeposit"></addDeposit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/columns";
import editSet from "./edit.vue";
import addDepositSet from "./addDeposit.vue";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      height: this.$store.getters.MainHeight,
      url: this.$url.report.productDepositList,
      count: this.$url.report.productDepositCount,
      columns: config.columns,
      query: {
        beginTime: new Date(),
        endTime: new Date(),
        keyword: "",
        staffIds: "",
        mobile: "",
        status: ""
      },
      staffList: [],
      totalCount: 0
    };
  },
  components: {editSet,addDepositSet},
  created() {
    this.getStaffList();
    this.totalCounts();
  },

  destroyed() {
    
  },

  methods: {
    searchDoQuery() {
      this.query.start = 1
      this.totalCounts();
    },
    getStaffList() {
      this.$api.get(this.$url.companyStaff.list, {filterStatus: 'disable'}).then(res => {
        if (res) {
          this.staffList = res;
        }
      })
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    },
    handleClick (item, index) {
      this.$refs["editForm"].$emit("set", item.id);
    },
    refreshPage(org) {
      if (org) {
        this.getData();
      }
    },
    totalCounts () {
      this.$api.post(this.$url.report.productDepositCount, this.query).then(res => {
        this.getData();
        this.totalCount = res || 0;
      }).catch(error => {});
    },
    addClick(item) {
      console.log(item)
      if (item && item.id) {
        // this.$refs["addDepositForm"].$emit("set", item);
        this.$refs["addDepositForm"].$emit("set", {orderId:"",sourceFrom:""});
      } else {
        // this.$refs["addDepositForm"].$emit("set");
        this.$refs["addDepositForm"].$emit("set", {orderId:"",sourceFrom:""});
      }
    },
    addDeposit(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
  }
};
</script>

<style lang='less' scoped>
@import "../../../assets/css/edit.less";
.page-head {
  // position: relative;
  height: 100%;
}
.deposit-pages {
  position: relative;
  // padding: 16px 16px 0;
}
.mains-content {
  background-color: #fff;
  border-radius: 10px;
  .member-header {
    background: #fff;
    padding: 16px 16px 0;
    display: flex;
    align-items: center;
    border-radius: 10px;
    .top-label {
      width: 90px;
    }
  }
}

</style>